import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { PainelControleRiscoResponse } from 'src/app/@shared/models/painel-risco.model';
import { PainelControleRiscoService } from 'src/app/services/painel-controle-risco/painel-controle-risco.service';

@Component({
  selector: 'app-painel-controle-risco-grid-detalhes',
  templateUrl: './painel-controle-risco-grid-detalhes.component.html',
  styleUrls: ['./painel-controle-risco-grid-detalhes.component.scss']
})
export class PainelControleRiscoGridDetalhesComponent implements OnInit, OnChanges {
  @Input() filters: any;
  private subscriptions: Array<Subscription> = [];

  displayedColumns: string[] = [
    'nrt',
    'documento',
    'volumetria',
    'cliente',
    'produto',
    'filial',
    'ufDestino',
    'dtEntrada',
  ];
  disableExcel = false;

  public isLoading: boolean;
  public isLoadingDownload: boolean;
  public dataSource: any;

  constructor(
    private painelControleRiscoService: PainelControleRiscoService,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() { }

  ngOnChanges() {
    this.carregarGrid();
  }

  public carregarGrid() {
    if (this.filters) {
      this.isLoading = true;
      this.subscriptions.forEach((subscription: Subscription) => {
        subscription.unsubscribe();
        console.log(subscription);
      });
      console.log(this.subscriptions);
      this.subscriptions.push(
        this.painelControleRiscoService.listarPainelControleRisco(
          Object.assign(this.filters, {
            paginaAtual: this.filters.paging.index + 1,
            itensPorPagina: this.filters.paging.size,
          })
        )
          .subscribe(
            (response: PainelControleRiscoResponse[]) => {
              this.dataSource = response;
              this.filters.paging.length = response.length > 0 ? response[0].totalCount : 0;

              if (response[0]?.totalCount > 1000000) {
                this.disableExcel = true;
              } else {
                this.disableExcel = false;
              }

            },
            (err: HttpErrorResponse) => {
              console.error(err);
              this.openSnackBar('Ocorreu um erro ao consultar! Tente novamente ou entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
            },
            () => this.isLoading = false
          ));
    }
  }

  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  gerarArquivo(data: any, filename: string, type: string) {
    const arrBuffer = this.base64ToArrayBuffer(data)
    const blob = new Blob([arrBuffer], {
      type
    });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadExcel() {
    this.isLoadingDownload = true;
    this.painelControleRiscoService.exportaExcel(this.filters).subscribe(
      (response: any) => {
        this.gerarArquivo(
          response.retorno.fileContents,
          response.retorno.fileDownloadName,
          response.retorno.contentType
        )
      },
      (err: HttpErrorResponse) => console.error('erro', err),
      () => this.isLoadingDownload = false
    )
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }


  onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.isLoading = true;
    this.filters.paging.index = evt.pageIndex;
    this.filters.paging.size = evt.pageSize;
    this.carregarGrid();
  }
}
